var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"youthIntro"},[_c('img',{attrs:{"src":require("@/assets/img/team/youth/partners.png"),"alt":"partners"}})])])])
}]

export { render, staticRenderFns }